@let entities = config().entities;
<div class="flex items-start">
  <table size="m" tuiTable [columns]="formGridService.columnsKey()">
    <thead pxcObserveHeightAsVar="--pxc-header-h" pxcObserveHeightAsVarTarget="table" tuiThead>
      <tr tuiThGroup>
        <th
          *tuiHead="formGridService.HEADER_COLUMN"
          class="bg-background-primary-alt! w-32 md:w-64 xl:w-96"
          tuiTh
          [sorter]="null"
          [sticky]="true"></th>
        @for (entity of entities; track entity.entityKey) {
          <th
            *tuiHead="formGridService.entityColumnKey(entity.entityKey)"
            class="w-80"
            tuiTh
            [attr.data-testid]="'entity-header-' + entity.entityKey"
            [sorter]="null">
            <ng-container *ngTemplateOutlet="config().headerCell; context: { $implicit: entity }" />
          </th>
        }
      </tr>
    </thead>

    @for (group of formGridService.groups(); track group.type) {
      <tbody tuiTbody [attr.data-testid]="'group-' + group.type" [data]="[]">
        <tr class="group-row" tuiTr [style.--row-z]="zIndexService.groupZ(group.type)">
          <th
            *tuiCell="formGridService.HEADER_COLUMN"
            class="label-col font-medium! bg-background-secondary-alt! py-4! text-base! max-w-96"
            pxcObserveHeightAsVar="--pxc-group-h"
            pxcObserveHeightAsVarTarget="tbody"
            tuiTd>
            {{ group.label }}
          </th>
          @for (entity of entities; track entity.entityKey) {
            <td
              *tuiCell="formGridService.entityColumnKey(entity.entityKey)"
              class="bg-background-secondary-alt! text-base!"
              tuiTd>
              <pxc-form-grid-group-header-cell [entityKey]="entity.entityKey" [type]="group.type" />
              @for (
                autoModule of autoModules(entity.entityKey, group.type);
                track autoModule.targetId + '::' + autoModule.moduleId
              ) {
                <pxc-form-auto-trigger
                  [autoModule]="autoModule"
                  [moduleInputs]="moduleInputs(entity.entityKey, group.type)"
                  (moduleTriggered)="applyModule(entity.entityKey, group.type, $event)" />
              }
            </td>
          }
        </tr>

        @if (group.projection; as projection) {
          <tr class="projection-row" tuiTr [style.--row-z]="zIndexService.groupZ(group.type) - 1">
            <th
              *tuiCell="formGridService.HEADER_COLUMN"
              class="label-col bg-background-primary! text-text-secondary font-medium! text-sm! max-w-96"
              tuiTd>
              <span class="flex items-center gap-1">
                {{ projection.label }}
                @if (projection.required) {
                  <span class="text-text-error-primary">*</span>
                }
              </span>
            </th>
            @for (entity of entities; track entity.entityKey) {
              <td *tuiCell="formGridService.entityColumnKey(entity.entityKey)" class="bg-background-primary!" tuiTd>
                <ng-container
                  *ngTemplateOutlet="
                    projection.content;
                    context: { $implicit: entity, mode: formGridService.mode(entity.entityKey, group.type) }
                  " />
              </td>
            }
          </tr>
        }

        @for (section of formGridService.visibleSections(group.type)(); track section.id) {
          <tr class="section-row" tuiTr [style.--row-z]="zIndexService.sectionLabelZ(group.type, section.id)">
            <th
              *tuiCell="formGridService.HEADER_COLUMN"
              class="label-col bg-background-secondary! text-text-secondary font-medium! text-sm! max-w-96"
              tuiTd>
              {{ section.title || section.label }}
            </th>
            @for (entity of entities; track entity.entityKey) {
              <td *tuiCell="formGridService.entityColumnKey(entity.entityKey)" pxc-form-grid-section-cell tuiTd>
                <pxc-form-grid-section-cell
                  [entityKey]="entity.entityKey"
                  [sectionId]="section.id"
                  [type]="group.type" />
              </td>
            }
          </tr>

          @for (question of formGridService.visibleQuestions(group.type, section.id)(); track question.id) {
            <tr class="question-row" tuiTr [style.--row-z]="zIndexService.sectionQuestionsZ(group.type, section.id)">
              <th
                *tuiCell="formGridService.HEADER_COLUMN"
                class="label-col bg-background-primary! text-text-tertiary text-sm!"
                tuiTd>
                <pxc-form-question-label mode="grid" [question]="question" />
              </th>
              @for (entity of entities; track entity.entityKey) {
                <td
                  *tuiCell="formGridService.entityColumnKey(entity.entityKey)"
                  pxc-form-grid-cell
                  tuiTd
                  [isHidden]="
                    formGridService.isSectionHidden(entity.entityKey, group.type, section.id) ||
                    formGridService.isQuestionHidden(entity.entityKey, group.type, question.id)
                  "
                  [isReadonly]="formGridService.mode(entity.entityKey, group.type) === 'readonly'">
                  <pxc-form-grid-question-cell
                    [entityKey]="entity.entityKey"
                    [question]="question"
                    [sectionId]="section.id"
                    [type]="group.type" />
                </td>
              }
            </tr>
          }
        }
      </tbody>
    }
  </table>
</div>
